<span >Follow the below steps to activate <span style="color: red;">Complinity</span> modules for your organisation.
</span>
<div class="grid">
    <div class="col-12 md:col-4" *ngFor="let card of cards">
      <p-card class="custom-card">
        <ng-template pTemplate="header">
          <h3 class="title">Step {{card.no}}. {{ card.title }}</h3>
        </ng-template>
        <ng-template pTemplate="content">
          <p class="description">{{ card.description }}</p>
        </ng-template>
        <ng-template pTemplate="footer">
          <button pButton label="Add/Edit" icon="pi pi-pencil" class="p-button-sm" (click)="navigateToMaster(card.title)"></button>
        </ng-template>
      </p-card>
    </div>
  </div>